import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoExchangeComponent } from './info-exchange.component';
import { DataModule } from '../../data/data.module';

@NgModule({
  declarations: [
    InfoExchangeComponent
  ],
  imports: [
    CommonModule,
    DataModule
  ], exports: [
    InfoExchangeComponent
  ]
})
export class InfoExchangeModule { }
